import PyramidInfoSection from './PyramidInfoSection';

export default PyramidInfoSection;
